'use client';
import { useTranslations } from 'next-intl';

export function KagemaneCatalogNotice({ error, retry }: { error: boolean; retry: () => void }) {
  const t = useTranslations('kagemane');
  if (!error) return null;
  return <div role="alert" className="mb-4 flex flex-wrap items-center gap-3 rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-900">
    <p>{t('catalogFailed')}</p><button type="button" onClick={retry} className="min-h-9 rounded-lg px-3 font-semibold underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4ABDE9]">{t('catalogRetry')}</button>
  </div>;
}
